import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
export function NotForEveryoneSection() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto text-center" data-id="element-137">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="border-t border-b border-zinc-800 py-12" data-id="element-138">
        <div className="inline-flex items-center justify-center p-3 bg-zinc-900 rounded-full mb-6" data-id="element-139">
          <AlertTriangle className="w-8 h-8 text-zinc-500" data-id="element-140" />
        </div>

        <h2 className="text-3xl font-heading font-bold text-white mb-8 uppercase" data-id="element-141">
          Esto no es para todos.
        </h2>

        <p className="text-xl text-zinc-400 mb-6" data-id="element-142">
          No es para el que quiere seguir improvisando.
        </p>

        <p className="text-2xl text-white font-medium leading-relaxed max-w-2xl mx-auto" data-id="element-143">
          Es para el que ya se cansó de vivir{' '}
          <span className="text-amber-500 font-bold" data-id="element-144">explotado el finde</span> y
          quiere empezar a{' '}
          <span className="border-b-2 border-amber-500" data-id="element-145">trabajar con plan</span>
          .
        </p>
      </motion.div>
    </section>;
}